import React from 'react';
import { Router, type RouterProps } from 'react-router-dom';
import history from '@history';

type BrowserRouterProps = Pick<RouterProps, 'basename' | 'children'>;

function BrowserRouter({ basename, children }: BrowserRouterProps) {
	const [state, setState] = React.useState({
		action: history.action,
		location: history.location
	});

	React.useLayoutEffect(() => history.listen(setState), []);

	return (
		<Router basename={basename} location={state.location} navigationType={state.action} navigator={history}>
			{children}
		</Router>
	);
}

export default BrowserRouter;
